export const  GET_AGENCY_INCIDENTS = 'GET_AGENCY_INCIDENTS';
export const FLAG_GETTING_AGENCY_INCIDENTS = 'FLAG_GETTING_AGENCY_INCIDENTS';
export const CLEAR_AGENCY_INCIDENTS = 'CLEAR_AGENCY_INCIDENTS';

export const ACTIVITY_AGENCY_INCIDENT = 'ACTIVITY_AGENCY_INCIDENT';
